import { Component, OnInit, HostBinding, ChangeDetectorRef } from '@angular/core';
import { Router, Event, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss']
})
export class DrawerComponent implements OnInit {
  
  @HostBinding('class.drawer-open') drawerOpened: boolean = false;

  constructor(private cdRef:ChangeDetectorRef, private router: Router) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.drawerOpened = false;
      }
    });
  }

  toggleDrawer() { 
    this.drawerOpened = !this.drawerOpened;
  }

  ngOnInit() {
  }

}
